module.exports = __webpack_public_path__ + "a8688fad934d09761d619d725076de6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/team/Leadership_Greg.jpg
// module id = 407
// module chunks = 0